// Static content for informational / legal pages
export const CONTENT = {
  delivery: {
    label: "Delivery",
    title: "Delivery Information",
    intro: "Fresh, authentic food delivered fast across the Netherlands and beyond.",
    sections: [
      { h: "Delivery areas", p: "We currently deliver within a 10 km radius of every partner kitchen. Enter your postcode at checkout to confirm availability in your area." },
      { h: "Timing", p: "Most orders arrive within 30–45 minutes. Chef's-table and multi-course menus may require a scheduled slot, shown at checkout." },
      { h: "Delivery fee", p: "A flat €2.99 delivery fee applies per order. Free delivery is unlocked on selected promotions and for Loyalty & Rewards members." },
      { h: "Contactless delivery", p: "Choose contactless delivery at checkout and our couriers will leave your order at the door and notify you." },
    ],
  },
  refund: {
    label: "Policy",
    title: "Order & Refund Policy",
    intro: "Your satisfaction is our priority. Here's how orders, cancellations and refunds work.",
    sections: [
      { h: "Cancellations", p: "Orders can be cancelled free of charge up until the chef begins preparation. After preparation starts, cancellation may not be possible." },
      { h: "Refunds", p: "If something is wrong with your order, contact support within 24 hours and we'll make it right — a refund, credit or re-delivery." },
      { h: "Processing time", p: "Approved refunds are returned to your original payment method within 5–10 business days." },
      { h: "Missing or incorrect items", p: "Report any missing or incorrect items via your dashboard or customersupport@jollanda.com and we'll resolve it quickly." },
    ],
  },
  terms: {
    label: "Legal",
    title: "Terms & Conditions",
    intro: "The rules of using Jollanda. By using our platform you agree to these terms.",
    sections: [
      { h: "Using Jollanda", p: "Jollanda connects eaters with verified independent chefs and restaurants. You must be 18+ to place an order and provide accurate information." },
      { h: "Orders & payment", p: "All prices are shown in euros (€) and include applicable taxes unless stated. Payment is taken at checkout and orders are confirmed once accepted by the kitchen." },
      { h: "Chef responsibilities", p: "Partner chefs are responsible for food safety, allergen accuracy and the quality of their dishes. Jollanda verifies partners but does not prepare food." },
      { h: "Liability", p: "Jollanda is not liable for indirect damages arising from use of the platform beyond the value of the order in question." },
    ],
  },
  privacy: {
    label: "Legal",
    title: "Privacy Policy",
    intro: "We take your privacy seriously and only collect what we need to serve you great food.",
    sections: [
      { h: "What we collect", p: "Account details (name, email), delivery address, order history and device information used to improve the service." },
      { h: "How we use it", p: "To process orders, personalise recommendations, prevent fraud and communicate about your orders. We never sell your data." },
      { h: "Your rights", p: "Under GDPR you can access, correct or delete your data at any time. Contact admin.ken@jollanda.com to make a request." },
      { h: "Cookies", p: "We use essential and analytics cookies to keep the site working and understand how it's used. You can manage preferences in your browser." },
    ],
  },
  sustainability: {
    label: "Impact",
    title: "Sustainability",
    intro: "Good food should be good for the planet, too.",
    sections: [
      { h: "Local sourcing", p: "We champion chefs who source seasonal, local ingredients — reducing food miles and supporting local growers." },
      { h: "Eco packaging", p: "All partner kitchens use compostable or recyclable packaging. We're on track to be 100% plastic-free." },
      { h: "Zero food waste", p: "Smart demand forecasting and surplus donations help our chefs minimise waste every single day." },
      { h: "Greener delivery", p: "Bike and electric-vehicle couriers handle the majority of city deliveries." },
    ],
  },
  corporate: {
    label: "Business",
    title: "Corporate & Catering Services",
    intro: "Authentic, memorable food for teams, events and celebrations of any size.",
    sections: [
      { h: "Office catering", p: "Recurring lunches, team socials and client lunches from verified chefs — booked in a few clicks with consolidated invoicing." },
      { h: "Events & celebrations", p: "From intimate dinners to 500-guest events, our chefs craft bespoke international menus tailored to your occasion." },
      { h: "Corporate accounts", p: "Centralised billing, spending controls and dedicated account management for organisations." },
      { h: "Get a quote", p: "Reach our catering team at admin.ken@jollanda.com or call 0685973458 to plan your event." },
    ],
  },
  blog: {
    label: "Community",
    title: "Community & Blog",
    intro: "Stories, recipes and the people behind the food.",
    sections: [
      { h: "Chef spotlights", p: "Meet the independent chefs turning heritage recipes into thriving businesses on Jollanda." },
      { h: "Recipes & guides", p: "Behind-the-scenes techniques and the cultural stories that make each dish special." },
      { h: "Events", p: "Pop-ups, supper clubs and tastings happening in your city. Join the community and never miss out." },
      { h: "Join in", p: "Follow us on social media and share your Jollanda moments with #LekkerWithYou." },
    ],
  },
  rewards: {
    label: "Members",
    title: "Loyalty & Rewards",
    intro: "The more you savour, the more you earn.",
    sections: [
      { h: "Earn points", p: "Collect 1 point for every €1 spent. Points never expire while your account is active." },
      { h: "Unlock perks", p: "Redeem points for free delivery, exclusive chef menus and early access to new kitchens." },
      { h: "Tiers", p: "Climb from Taster to Connoisseur to unlock bigger rewards, birthday treats and priority support." },
      { h: "Refer a friend", p: "Give €10, get €10 — every time a friend places their first order." },
    ],
  },
  careers: {
    label: "Join us",
    title: "Careers",
    intro: "Help us bring authentic food and independent chefs to the world.",
    sections: [
      { h: "Why Jollanda", p: "A mission-driven team, real ownership, and the chance to shape how the world discovers food." },
      { h: "Open roles", p: "We're hiring across engineering, operations, chef partnerships and marketing. Roles are updated regularly." },
      { h: "Our values", p: "Craft, community and authenticity guide everything we do — inside and outside the kitchen." },
      { h: "Apply", p: "Send your CV and a note about your favourite dish to admin.ken@jollanda.com." },
    ],
  },
};
